define('rehash/rehash',['require','ensureArray/ensureArray','deepObject/get'],function(require) {

    var ensureArray = require('ensureArray/ensureArray');
    var deep        = require('deepObject/get');

    return function (source, property, maintainSourceKey, modifySource) {

        var target = modifySource ? source : {}, sourceKey, sourceVal, targetKey;

        for (sourceKey in source) {
          if (source.hasOwnProperty(sourceKey)) {

            sourceVal = source[sourceKey];

            // Convert to string to allow rehashing by booleans!
            targetKey = property ? '' + deep(sourceVal, property) : property;

            if (targetKey) {

              if (targetKey in target) {
                (target[targetKey] = ensureArray(target[targetKey])).push(sourceVal);
              } else {
                target[targetKey] = sourceVal;
              }

              if (modifySource && !maintainSourceKey) {
                delete target[sourceKey];
              } else if (maintainSourceKey && !modifySource) {
                target[sourceKey] = sourceVal;
              }
            }

          }
        }

        return target;
    }
});
